import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import RecordForm from '@shoflo/polymer/components/RecordForm/RecordForm';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import createRecording from 'actions/Broadcast/recording/createRecording';
import updateRecording from 'actions/Broadcast/recording/updateRecording';

import ModalHeader from 'components/Modal/Header';
import { LIVE_RECORDING_FORM } from 'constants/ModalTypes';

const LiveRecordingForm = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === LIVE_RECORDING_FORM
  );

  const liveRecording = useSelector(({ modal }) =>
    modal ? modal.initialValue : null
  );

  const dispatch = useDispatch();

  const clearThisModal = () => dispatch(clearModal(LIVE_RECORDING_FORM));

  const handleSubmit = recording => {
    if (liveRecording) {
      dispatch(updateRecording(recording, liveRecording));
    } else {
      dispatch(createRecording(recording));
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={clearThisModal}>
      <ModalHeader>Add live cloud recording</ModalHeader>
      <ModalBody>
        <RecordForm
          onSubmit={recording => {
            clearThisModal();
            handleSubmit(recording);
          }}
          onCancel={clearThisModal}
          recording={liveRecording}
        />
      </ModalBody>
    </Modal>
  );
};

export default LiveRecordingForm;
